import React from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "@/data/constants";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#080f22] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <div className="text-2xl font-head font-extrabold text-white">europe<span className="text-[#FFD166]">jobs</span></div>
            <div className="text-sm text-slate-400 mt-1">{t("footer.tagline")} 🇲🇽🇵🇱</div>
          </div>
          <div className="flex flex-wrap gap-6 text-sm text-slate-300">
            <a href="#vacantes" className="hover:text-[#FFD166]">{t("footer.vacantes")}</a>
            <a href="#nosotros" className="hover:text-[#FFD166]">{t("footer.nosotros")}</a>
            <a href="#empresas" className="hover:text-[#FFD166]">{t("footer.empresas")}</a>
            <a href="#contacto" className="hover:text-[#FFD166]">{t("footer.contacto")}</a>
            <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="hover:text-[#25D366]">WhatsApp</a>
            <Link to="/admin/login" className="hover:text-white">{t("nav.admin")}</Link>
          </div>
        </div>
        <div className="border-t border-white/10 mt-8 pt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} EuropeJobs.pro · {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};
